/* import __COLOCATED_TEMPLATE__ from './project-cancellation-confirm.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

export default class ProjectCancellationConfirm extends Component {
  @service router;

  @tracked isProjectCancelTalkedAboutProject = false;
  @tracked isProjectCancelMakeProjectWork = false;
  @tracked isProjectCancelIsMadeAgreement = false;

  get isContinueButtonDisabled() {
    return !this.isProjectCancelTalkedAboutProject ||
      !this.isProjectCancelMakeProjectWork ||
      !this.isProjectCancelIsMadeAgreement;
  }

  @action
  onConfirmCheckboxClicked(checkboxValue) {
    this[checkboxValue] = !this[checkboxValue];
  }

  @action
  onContinueClicked() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.PROJECT__CANCELLATION__DETAILS, this.args.application.id);
  }

  @action
  onBackClicked() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.PROJECT__DETAILS__ACTIVITY, this.args.application.id);
  }
}
